<template>
  <div
    class="embed"
    v-bind:style="{paddingBottom: ratio + '%'}"
  >
    <div class="embed-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Embed',
    props: {
      ratio: String
    },
  }
</script>

<style>
  .embed {
    position: relative;
    display: block;
    width: 100%;
    padding: 0;
    overflow: hidden;
  }

  .embed::before {
    display: block;
    content: "";
  }

  .embed-content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }

  .embed-content img,
  .embed-content video {
    max-width: 100%;
    max-height: 100%;
    height: auto;
  }
</style>
